"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Reorder(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M9.7 17.283l1.287 1.301 1.004 1.004 2.3-2.298a.995.995 0 0 1 1.413 0 1.003 1.003 0 0 1 0 1.414l-.177.177-2.8 2.786-.036.035c-.02.022-.035.05-.063.064a1.016 1.016 0 0 1-.255.155c-.057.014-.12.036-.19.05a.974.974 0 0 1-.899-.262L8.28 18.704a1.003 1.003 0 0 1-.283-.707c-.007-.262.1-.509.283-.707a1.003 1.003 0 0 1 1.421-.007zM20 12.994c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1h16zm0-4c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1h16zm-7.293-6.71l3.005 3.006c.184.198.29.445.283.707a.999.999 0 0 1-.283.707 1.005 1.005 0 0 1-1.42.007l-1.288-1.3L12 4.405 9.702 6.704A1 1 0 0 1 8.288 5.29l.177-.177 2.8-2.786.035-.035c.021-.022.035-.05.063-.064.078-.064.156-.113.255-.156.057-.013.12-.035.191-.049a.975.975 0 0 1 .898.261z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Reorder;
